import React from 'react'
import styled, { css } from 'styled-components'

import { Heading2, Heading4 } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Subheading = styled(Heading4)`
  margin-bottom: 48px;
`

const Row = styled.div`
  display: flex;
  column-gap: 16px;
  :not(:last-child) {
    margin-bottom: 48px;
  }
`

const Item = styled.div`
  width: 25%;
  background-color: #f0f1f6;
  padding: 8px 8px 16px;
  ${(p) => p.dark && 'background-color:#300D4F; color: white;'}
`

const ItemHeading = styled.div`
  margin-bottom: 24px;
  font-weight: 600;
  font-size: 20px;
  line-height: 170%;
  letter-spacing: 0.5px;
`

const ButtonWrapper = styled.div`
  border: 2px solid transparent;
  border-radius: 8px;
  padding: 3px;
  ${(p) => p.focused && 'border: 2px solid #458fff;'}
`

const Button = styled.button`
  width: 100%;
  padding: 8px 16px;
  background-color: #300d4f;
  border: 2px solid transparent;
  border-radius: 4px;
  font-weight: 600;
  font-size: 16px;
  line-height: 175%;
  letter-spacing: 0.5px;
  color: white;
  :hover {
    background-color: white;
    border: 2px solid #300d4f;
    color: ${(p) => p.theme.textColor};
  }
  :active {
    background-color: #ff8de3;
    border: 2px solid #ff8de3;
    color: ${(p) => p.theme.textColor};
  }
  ${(p) =>
    p.hover &&
    css`
      background-color: white;
      border: 2px solid #300d4f;
      color: ${(p) => p.theme.textColor};
    `}
  ${(p) =>
    p.pressed &&
    css`
      background-color: #ff8de3 !important;
      border: 2px solid #ff8de3 !important;
      color: ${(p) => p.theme.textColor} !important;
    `}
  ${(p) =>
    p.dark &&
    css`
      background-color: white;
      border: 2px solid white;
      color: ${p.theme.textColor};
      :hover {
        background-color: #300d4f;
        border: 2px solid white;
        color: white;
      }
      ${(p) =>
        p.hover &&
        css`
          background-color: #300d4f;
          border: 2px solid white;
          color: white;
        `}
    `}
`

const Buttons = () => {
  return (
    <>
      <Heading>Buttons</Heading>
      <Subheading>Primary buttons</Subheading>
      <Row>
        <Item>
          <ItemHeading>Default</ItemHeading>
          <ButtonWrapper>
            <Button>Find out more</Button>
          </ButtonWrapper>
        </Item>
        <Item>
          <ItemHeading>Hover</ItemHeading>
          <ButtonWrapper>
            <Button hover>Find out more</Button>
          </ButtonWrapper>
        </Item>
        <Item>
          <ItemHeading>Focussed</ItemHeading>
          <ButtonWrapper focused>
            <Button>Find out more</Button>
          </ButtonWrapper>
        </Item>
        <Item>
          <ItemHeading>Pressed</ItemHeading>
          <ButtonWrapper>
            <Button pressed>Find out more</Button>
          </ButtonWrapper>
        </Item>
      </Row>
      <Row>
        <Item dark>
          <ItemHeading>Default</ItemHeading>
          <ButtonWrapper>
            <Button dark>Find out more</Button>
          </ButtonWrapper>
        </Item>
        <Item dark>
          <ItemHeading>Hover</ItemHeading>
          <ButtonWrapper>
            <Button dark hover>
              Find out more
            </Button>
          </ButtonWrapper>
        </Item>
        <Item dark>
          <ItemHeading>Focussed</ItemHeading>
          <ButtonWrapper focused>
            <Button dark>Find out more</Button>
          </ButtonWrapper>
        </Item>
        <Item dark>
          <ItemHeading>Pressed</ItemHeading>
          <ButtonWrapper>
            <Button dark pressed>
              Find out more
            </Button>
          </ButtonWrapper>
        </Item>
      </Row>
    </>
  )
}

export default Buttons
